import { RootState } from "store/types";

export const selectEventList = (state: RootState) => state.eventList;
